export default "__VITE_ASSET__5d189887__"